<template>
<div class="picture" id="picture">
  <div class="row">
      <div class="col-6" v-for="c in captures" v-bind:key="c">
          <img v-bind:src="c" height="250" width="250" align="center" id="img" style="cursor: -moz-zoom-in;" 
          onclick="this.width=596;this.height=435;" ondblclick="this.width=250;this.height=250;" title="Clicca qui per vedere lo zoom della foto"
          />
        <button class="fa fa-trash"
                aria-hidden="true"
                id="buttonremove"
                @click="removeImg(c)">
                </button>
      </div>
  </div>
</div>
</template>

<script>
export default {
name: 'picture',
 props: {
    captures: Array
  },

 data: function() {
    return {
      //captures: []
    };
  },

 methods: {

 removeImg (img)  {
   var NewCaptures = [];
   for(var i=0;i<this.captures.length;i++){
     if(img!=this.captures[i]){
       NewCaptures.push(this.captures[i]);
     }
   }
   this.captures = NewCaptures;


/*let captures = [0,1,2,3];

delete captures [0,1,2,3];

    $("#img").remove();
    $("#buttonremove").remove();
    spinnerHelpers.hide();
    $("#img").addClass("active");*/
    }
   }
};
</script>

<style lang="scss" scoped>
.picture {
  display: block;
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
  

img#img {
    vertical-align: unset;
    border-style: outset;
  
}


  canvas  {
    display:none;
    width: 50%;
      margin: 0 auto;
      box-shadow: 6px 6px 12px 0px transparentize($color: #171717, $amount: 0.5);
}
}
</style>